import service from './service';
import { UrlBuilder } from './url-builder';

const sosList = async (page, pageSize) => {
  const builder = new UrlBuilder(`users/self/soss`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export { sosList };
